import '../styles/index.sass';
console.log('webpack starterkit');

$(document).ready(function () {
  AOS.init();
});
